import { Types } from '../../../constants';
import { WrapHelper } from '../WrapHelper';
export class WrapInputHelper extends WrapHelper {
    constructor() {
        super(...arguments);
        this.type = Types.Input;
    }
}

//# sourceMappingURL=WrapInputHelper.js.map
